import { fakers } from "@/mocks/faker";
import { CreateClientRequest, ListClientsResponse } from "../api/client";

const faker = fakers.clients;

export const fakeClient = (): ListClientsResponse => ({
  id: faker.string.uuid(),
  cnpj: `${faker.string.numeric(2)}.${faker.string.numeric(3)}.${faker.string.numeric(3)}/${faker.string.numeric(4)}-${faker.string.numeric(2)}`,
  name: faker.company.name(),
  fantasyName: faker.company.name(),
  responsibleName: faker.person.fullName(),
});

export const fakeClientsList = (count = 10): ListClientsResponse[] =>
  Array.from({ length: count }, fakeClient);

export const fakeCreateClientPayload = (): CreateClientRequest => ({
  cnpj: `${faker.string.numeric(2)}.${faker.string.numeric(3)}.${faker.string.numeric(3)}/${faker.string.numeric(4)}-${faker.string.numeric(2)}`,
  name: faker.company.name(),
  fantasyName: faker.company.name(),
  phone: `(${faker.string.numeric(2)}) ${faker.string.numeric(5)}-${faker.string.numeric(4)}`,
  municipalRegistration: faker.string.numeric(9),
  address: {
    zipCode: `${faker.string.numeric(5)}-${faker.string.numeric(3)}`,
    street: faker.location.street(),
    complement: faker.location.secondaryAddress(),
    neighborhood: faker.location.county(),
    number: Number(faker.string.numeric(3)),
    city: faker.location.city(),
    state: faker.location.state(),
    country: "Brasil",
  },
  responsible: {
    name: faker.person.fullName(),
    email: faker.internet.email(),
    phone: `(${faker.string.numeric(2)}) ${faker.string.numeric(5)}-${faker.string.numeric(4)}`,
  },
});
